import React from "react";
import ProviderBusiness from "./ProviderBusiness";
import { FormProvider } from "../../context/FormContext";

const ProviderForm = () => {
  return (
    <>
      <FormProvider>
        <ProviderBusiness />
      </FormProvider>
    </>
  );
};

export default ProviderForm;
